import React, { useEffect, useState } from 'react';
import { getFirestore, collection, query, getDocs, orderBy, limit } from 'firebase/firestore';
import Burger from './Burger';
import { useNavigate } from 'react-router-dom';

const Leaderboard = () => {
  const navigate = useNavigate();
  const [players, setPlayers] = useState([]);
  const [loading, setLoading] = useState(true);
  const firestore = getFirestore();

  const fetchLeaderboard = async () => {
    setLoading(true);
    try {
      const lbRef = collection(firestore, 'leaderboard');
      const q = query(lbRef, orderBy('bestScore', 'desc'), limit(100));
      const snap = await getDocs(q);
      const rows = snap.docs.map(d => ({ id: d.id, ...d.data() }));
      setPlayers(rows);
    } catch (err) {
      console.error('Error fetching leaderboard:', err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { fetchLeaderboard(); }, []);

  return (
    <div className="background-register" style={{
      width: '100vw', height: '100vh', display: 'flex', justifyContent: 'center',
      flexDirection: 'column', alignItems: 'center',
    }}>
      <div style={{
        width: '550px', height: '90vh', display: 'flex', justifyContent: 'flex-start',
        alignItems: 'center', flexDirection: 'column', backgroundColor: '#e4299c',
        borderRadius: '19px', padding: '20px', gap: '10px'
      }}>
        <img src="/Leaderboard.png" alt="Leaderboard" style={{ width: '230px' }} />
        <Burger />
              <button
        type="button"
        onClick={() => navigate("/")}
        aria-label="Go to homepage"
        style={{
          position: "absolute",
          top: "24px",
          left: "24px",
          background: "none",
          border: "none",
          padding: 0,
        }}
      >
        <img src="/neonlogo.png" alt="" style={{ width: "120px" }} />
      </button>
        {loading ? (
          <p>Loading...</p>
        ) : (
          <div style={{
            width: '350px', maxHeight: '500px', overflowY: 'auto', border: '5px solid #002366',
            borderRadius: '16px', padding: '10px', background: '#eef6ff'
          }}>
            {players.length === 0 ? (
              <p style={{ textAlign: 'center', color: '#eef6ff' }}>No game results found</p>
            ) : (
              players.map((p, index) => {
                const displayName = p.username || 'Unknown';
                const company = p.company || 'No company';
                const score = (Number(p.bestScore) || 0).toFixed(2);

                return (
                  <div key={p.id} style={{
                    display: 'flex', justifyContent: 'space-between', alignItems: 'center',
                    padding: '12px', borderBottom: '1px solid #002366', textAlign: 'left'
                  }}>
                    <div style={{ color: '#002366', display: 'flex', flexDirection: 'column', flex: 1 }}>
                      <strong>#{index + 1} {displayName}</strong>
                      <span style={{color: "#e4299c", fontSize: '14px' }}>{company}</span>
                    </div>
                    <div style={{ color: '#002366', fontWeight: 'bold', minWidth: '60px', textAlign: 'right' }}>
                      {score} pts
                    </div>
                  </div>
                );
              })
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default Leaderboard;
